<template>
    <div class="main-chart">
        <div id="chart">
            <apexchart :series="series" :options="options"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColumnChartEmployee",
    props: {
        series: {
            type: Array,
            required: true
        },
        activateChart: Boolean
    },
    data() {
        return {
            options: {
                title: {
                    text: this.$t('statistics.categories.employees'),
                    align: 'left',
                    margin: 10,
                    offsetX: 10,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '13px',
                        fontWeight: '700',
                        fontFamily: undefined,
                        color: '#959595'
                    },
                },
                chart: {
                    id: '5',
                    width: 10,
                    offsetX: -10,
                    offsetY: 5,
                    toolbar: {
                        show: false,
                    },
                    height: 30,
                    type: 'bar'
                },
                colors: ['#959595'],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        distributed: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                xaxis: {
                    labels: {
                        show: false,
                    },
                    axisTicks: {
                        show: false
                    },
                    tooltip: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                    },
                    tickAmount: 0,
                    axisTicks: {
                        show: false
                    }
                },
            }
        }
    },
    methods: {
        activeClass() {
            if (this.activateChart) {
                this.$apexcharts.exec('5', 'updateOptions', {
                    colors: ['#6f42c1'],
                    title: {
                        style: {
                            color: '#6f42c1'
                        }
                    }
                })
            }
        }
    },
    mounted() {
        this.activeClass()
    }
}
</script>

<style scoped>

</style>